import { action } from 'typesafe-actions';
import { IAlert, IApiList } from 'types';
import { IApiQueryOptions } from '../../../api/ApiClient';
import { Alerts } from './types';

export const getUserAlertsRequest = (options?: IApiQueryOptions) => action(Alerts.GET_USER_ALERTS_REQUEST, options);
export const getUserAlertsSuccess = (response: IApiList<IAlert>) => action(Alerts.GET_USER_ALERTS_SUCCESS, response);
export const getUserAlertsError = (error: any) => action(Alerts.GET_USER_ALERTS_FAIL, error);
